export default __webpack_public_path__ + "static/media/wwu-email.5dd715b3.png";